<template>
  <div class="dp-kopf elevation-1">
    <div class="dp-kopf-text">
      <span class="text-h6">{{ titel }}</span>
      <span v-if="untertitel" class="text-caption grey--text text--darken-1 ml-3 d-none d-md-inline">{{ untertitel }}</span>
    </div>
    <div class="dp-kopf-actions"><slot/></div>
  </div>
</template>

<script>
// Page header bar of the Dienstplanung pages (same height and look as the
// other Personalwesen masks).
export default {
  name: 'DpKopf',
  props: {
    titel: {type: String, required: true},
    untertitel: {type: String, default: ''},
  },
}
</script>

<style scoped>
.dp-kopf {
  display: flex;
  align-items: center;
  min-height: 2.55rem;
  padding: 2px 12px;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 4px;
  background: #fff;
  position: relative;
  z-index: 2;
}
.dp-kopf-text {
  flex: 1 1 auto;
  min-width: 0;
}
.dp-kopf-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
